"use client";

import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="230134" className="flex flex-col gap-2">
        <div className="h-4 w-20 bg-muted/10 animate-pulse rounded" />
        <div className="h-4 w-24 bg-muted/10 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted/10 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-col gap-2">
      {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-secondary-foreground hover:text-foreground transition-colors text-sm font-mono">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  return <section id="gtmx-labs-footer" className="bg-background text-foreground border-t border-border">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div data-index={0}>
            <Link to="/" className="inline-block mb-4">
              <WvcLogo className="h-7 w-auto" />
            </Link>
            <p className="text-sm text-secondary-foreground font-mono uppercase tracking-wider">
              Veteran-Owned Precision
            </p>
          </div>

          <div data-index={1}>
            
            <MenuProvider menu_id="26">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div data-index={2}>
            <h3 className="font-default font-bold text-base mb-4 uppercase tracking-tight">Legal</h3>
            <nav className="flex flex-col gap-2">
              <Link to="#" className="text-secondary-foreground hover:text-foreground transition-colors text-sm font-mono">
                Privacy Policy
              </Link>
              <Link to="#" className="text-secondary-foreground hover:text-foreground transition-colors text-sm font-mono">
                Terms of Service
              </Link>
            </nav>
          </div>

          
        </div>

        <Separator className="bg-border mb-6" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-secondary-foreground font-mono">
          <div className="flex items-center gap-6">
            <p>&copy; 2025 GTMX Labs. All rights reserved.</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="uppercase tracking-widest opacity-60">Defense Grade Tech</span>
            <span className="inline-flex items-center gap-1">
              <span className="inline-block w-3 h-2 bg-primary"></span>
              <span className="inline-block w-3 h-2 bg-secondary"></span>
              <span className="inline-block w-3 h-2 bg-accent-foreground"></span>
            </span>
          </div>
        </div>
      </div>
    </section>;
}